module.exports = __webpack_public_path__ + "static/img/element_02.01db325.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/element_02.png
// module id = JRTr
// module chunks = 24